import {  Component, ViewChild } from '@angular/core';

import * as moment from 'moment/moment';
import { BrowserUtil } from '../utils/browser.util';
import { ConfigService } from '../service/config.service';
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css']
})

export class FooterComponent {
    @ViewChild('linksdiv') linksWrapper;

    constructor(private browserUtil: BrowserUtil, private configService : ConfigService) {

    }

   public openFromMobile(e, download = false) {

        let webkit = this.browserUtil.nativeWindow.webkit;
        if (webkit) {
            e.preventDefault();
            e.stopPropagation();
            
            let url = e.target.href;
            if (!url) {
                url = e.target.parentNode.href;
            }
            var msg = JSON.stringify({ 'action': (download) ? 'download_file' : 'open_external', 'url': url });
            webkit.messageHandlers.cordova_iab.postMessage(msg);
        }
    }

    getFinancialYear() {
        return '2017' + '-' + moment().year();
    }

    getPolicyFileUrlByName(fileName) : string {
        return this.configService.getPolicyFileUrlByName(fileName);
        
    }
}
